/**
 * @generated SignedSource<<f000ed7e4dd12b343b3f62883978af1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImportSageIntacctCustomersInput = {
  sageIntacctCustomerIds?: ReadonlyArray<string | null> | null;
  companyId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ImportSageIntacctCustomersMutation$variables = {
  input: ImportSageIntacctCustomersInput;
};
export type ImportSageIntacctCustomersMutation$data = {
  readonly importSageIntacctCustomers: {
    readonly clients: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly notes: string | null;
        readonly logoId: string | null;
        readonly logoDefaultId: number | null;
        readonly projectCount: number | null;
        readonly economicCustomerId: string | null;
        readonly quickbooksCustomerId: string | null;
        readonly xeroContactId: string | null;
        readonly salesforceAccountId: string | null;
        readonly hubspotCompanyId: string | null;
        readonly pipedriveOrganizationId: string | null;
        readonly sageIntacctCustomerId: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type ImportSageIntacctCustomersMutation = {
  variables: ImportSageIntacctCustomersMutation$variables;
  response: ImportSageIntacctCustomersMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportSageIntacctCustomersPayload",
    "kind": "LinkedField",
    "name": "importSageIntacctCustomers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientTypeEdge",
        "kind": "LinkedField",
        "name": "clients",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoDefaultId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "economicCustomerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quickbooksCustomerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xeroContactId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salesforceAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hubspotCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pipedriveOrganizationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctCustomerId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportSageIntacctCustomersMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportSageIntacctCustomersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8fb6c31fb387c5dff1b10de0ed5f4157",
    "id": null,
    "metadata": {},
    "name": "ImportSageIntacctCustomersMutation",
    "operationKind": "mutation",
    "text": "mutation ImportSageIntacctCustomersMutation(\n  $input: ImportSageIntacctCustomersInput!\n) {\n  importSageIntacctCustomers(input: $input) {\n    clients {\n      cursor\n      node {\n        id\n        name\n        notes\n        logoId\n        logoDefaultId\n        projectCount\n        economicCustomerId\n        quickbooksCustomerId\n        xeroContactId\n        salesforceAccountId\n        hubspotCompanyId\n        pipedriveOrganizationId\n        sageIntacctCustomerId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b998220f3137c141c3183badf623d0e3";

export default node;
